<template>
    <div class="at1024:flex">
        <section class="pb-20 pt-9 px-4 at1024:px-0 at1024:py-0 at1024:w-2/5">
            <div
                class="max-w-md mx-auto at1024:left-[5%] at1024:max-w-none at1024:mx-0 at1024:pb-16 at1024:sticky at1024:top-60 at1024:w-80 at1200:w-96 at1550:left-[10%]"
            >
                <div
                    class="flex items-center min-h-24 max-w-lg p-4 mb-5 rounded-md bg-yellow"
                    v-if="Object.keys(form.errors).length"
                >
                    <span class="mr-3 p-3 rounded-full shrink-0 text-white">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="inline-block"
                            height="48"
                            viewBox="0 0 24 24"
                            width="48"
                            fill="#000000"
                        >
                            <path
                                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
                            />
                        </svg>
                    </span>

                    <p v-if="Object.keys(form.errors).length == 1">
                        <span v-for="(error, key) in form.errors" class="leading-tight">{{ error }}</span>
                    </p>

                    <ul v-else class="list-disc space-y-1">
                        <li v-for="(error, key) in form.errors" class="leading-none">{{ error }}</li>
                    </ul>
                </div>
                <h1 class="text-3xl at1024:text-5xl">Login</h1>
                <p class="text-gray">
                    Are you a security professional?
                    <Link
                        :href="route('register')"
                        class="underline hover:text-gray-800"
                    >Register now</Link
                    >.
                </p>

                <form
                    @submit.prevent="submit($event)"
                    :action="
                        route('login', {
                            redirect: route(route().current(),route().params),
                        })
                    "
                    method="post"
                    class="mt-5 space-y-4"
                >
                    <seclock-input
                        label="Email"
                        :animated="true"
                        type="email"
                        autocomplete="username"
                        v-model="form.email"
                    />
                    <seclock-input
                        label="Password"
                        :animated="true"
                        type="password"
                        autocomplete="current-password"
                        v-model="form.password"
                    />
                    <seclock-input
                        label="Remember Me?"
                        type="checkbox"
                        checked
                        name="remember"
                        v-model="form.remember"
                    />
                    <button
                        type="submit"
                        class="btn-white-on-black justify-center w-full"
                    >
                        Login
                    </button>
                </form>
                <p class="mt-7 text-center">
                    <Link
                        :href="route('password.request')"
                        class="text-gray underline hover:text-gray-800"
                    >Forgot Password?
                    </Link>
                </p>
            </div>
        </section>
        <!-- Manufacturer Preview (when coming from manufacturer detail page) -->
        <section v-if="manufacturer" class="bg-gradient-to-t from-gray-300 to-white at1024:w-3/5 at1350:overflow-x-hidden">
            <ManufacturerPreview
                :manufacturer="manufacturer"
                :series="series"
                :featuredSeries="featuredSeries"
                :vendorCategories="vendorCategories"
            />
        </section>
        <!-- Default Marketing Content (when no manufacturer context) -->
        <section v-else class="bg-gradient-to-t from-gray-300 to-white at1024:w-3/5 at1350:overflow-x-hidden">
            <div
                class="pt-14 relative at1024:pb-48 at1024:pt-24 at1440:pb-40 at1680:pb-56"
            >
                <div
                    class="mb-8 px-8 relative text-center at1024:max-w-3xl at1024:mb-12 at1024:mx-auto at1024:px-[60px] at1024:text-left"
                >
                    <h2
                        class="font-bold mb-4 text-[28px] tracking-[-.01em] at1024:text-4xl at1350:text-5xl"
                    >
                        Pro hardware sourcing.
                    </h2>
                    <p class="leading-6 text-gray text-lg at1024:text-xl">
                        Get exclusive access to the most comprehensive door
                        hardware and security search platform in the industry.
                        <a
                            href="/register"
                            class="font-medium ml-1 underline hover:text-gray-800"
                        >Register now</a
                        >
                    </p>
                </div>
                <div
                    class="pb-16 px-4 relative at1024:pb-0 at1024:px-[60px] at1350:-mx-[120px] at1350:px-0"
                >
                    <img
                        src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/about_val_laptop"
                        height="532"
                        width="920"
                        sizes="920px"
                        class="mx-auto"
                        loading="lazy"
                        alt="Our advanced product search tool on a laptop"
                    />
                </div>
            </div>
            <base-svg
                name="register-divider"
                class="hidden at1024:block at1024:relative at1024:-translate-y-72 at1024:w-full at1200:-translate-y-80 at1440:-translate-y-88 at1680:-translate-y-112"
            />
            <div
                class="bg-gradient-to-b from-black via-black to-[#525252] relative text-white at1024:-mt-72 at1200:-mt-80 at1440:-mt-88 at1680:-mt-112"
            >
                <span
                    class="absolute bg-cover bg-no-repeat bg-shape-paths-black bg-top h-full opacity-20 w-full"
                ></span>
                <div class="relative">
                    <div
                        class="pb-16 pt-28 px-8 text-center at1024:max-w-3xl at1024:mx-auto at1024:pt-16 at1024:px-16 at1024:text-left"
                    >
                        <h3
                            class="font-bold leading-8 text-2xl tracking-[-.01em] at1024:text-4xl"
                        >
                            Take advantage of all the account benefits on
                            SECLOCK.com.
                        </h3>
                    </div>
                    <div class="pb-16 px-4 at1024:px-16">
                        <a
                            href="/path/to/video"
                            aria-label="Watch the video about SECLOCK account benefits"
                            class="block group relative"
                        >
                            <base-svg
                                name="icon-play-circle"
                                class="absolute h-20 left-1/2 text-white top-1/2 -translate-x-1/2 -translate-y-1/2 w-20 group-hover:text-blue"
                                aria-hidden="true"
                            />
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/register-vid-poster"
                                height="420"
                                width="800"
                                sizes="800px"
                                class="mx-auto"
                                loading="lazy"
                                alt=""
                                aria-hidden="true"
                            />
                        </a>
                    </div>
                    <ul
                        class="gap-12 grid pb-16 px-8 text-center at768:grid-cols-2 at1024:max-w-[808px] at1024:mx-auto at1024:px-16 at1024:text-left"
                    >
                        <li class="text-lg at1024:text-xl">
                            <h3
                                class="flex flex-col font-semibold items-center leading-tight at1024:items-start"
                            >
                                <base-svg
                                    name="icon-filter-alt"
                                    class="h-12 mb-2 text-gray w-12 at1024:mb-3"
                                    aria-hidden="true"
                                />
                                Our powerful product filter tool
                            </h3>
                            <p class="leading-tight text-gray-300">
                                Find the exact item you need by narrowing down
                                your product search with our smart filters.
                            </p>
                        </li>
                        <li class="text-lg at1024:text-xl">
                            <h3
                                class="flex flex-col font-semibold items-center leading-tight at1024:items-start"
                            >
                                <base-svg
                                    name="icon-search"
                                    class="h-12 mb-2 text-gray w-12 at1024:mb-3"
                                    aria-hidden="true"
                                />
                                Find what you need with search
                            </h3>
                            <p class="leading-tight text-gray-300">
                                Start entering the part number or keyword for an
                                item and our auto-suggest will take over.
                            </p>
                        </li>
                        <li class="text-lg at1024:text-xl">
                            <h3
                                class="flex flex-col font-semibold items-center leading-tight at1024:items-start"
                            >
                                <base-svg
                                    name="icon-support-phone"
                                    class="h-12 mb-2 text-gray w-12 at1024:mb-3"
                                    aria-hidden="true"
                                />
                                Technical support at chat speed
                            </h3>
                            <p class="leading-tight text-gray-300">
                                Leverage the knowledge of the same technical
                                sales reps that you speak to on the phone via
                                our live chat tool.
                            </p>
                        </li>
                        <li class="text-lg at1024:text-xl">
                            <h3
                                class="flex flex-col font-semibold items-center leading-tight at1024:items-start"
                            >
                                <base-svg
                                    name="icon-catalogs-book"
                                    class="h-12 mb-2 text-gray w-12 at1024:mb-3"
                                    aria-hidden="true"
                                />
                                The industry's largest library of resources
                            </h3>
                            <p class="leading-tight text-gray-300">
                                Access our massive library of technical
                                documents, price books, catalogs and cut sheets.
                            </p>
                        </li>
                        <li class="text-lg at1024:text-xl">
                            <h3
                                class="flex flex-col font-semibold items-center leading-tight at1024:items-start"
                            >
                                <base-svg
                                    name="icon-products-cube"
                                    class="h-12 mb-2 text-gray w-12 at1024:mb-3"
                                    aria-hidden="true"
                                />
                                Current product inventory levels
                            </h3>
                            <p class="leading-tight text-gray-300">
                                Our vast in-stock inventory consists of the
                                broadest and deepest suite of products from over
                                100 premium manufacturers.
                            </p>
                        </li>
                        <li class="text-lg at1024:text-xl">
                            <h3
                                class="flex flex-col font-semibold items-center leading-tight at1024:items-start"
                            >
                                <base-svg
                                    name="icon-sell"
                                    class="h-12 mb-2 text-gray w-12 at1024:mb-3"
                                    aria-hidden="true"
                                />
                                Product list price and your price
                            </h3>
                            <p
                                class="leading-tight text-gray-300 at1024:text-xl"
                            >
                                View real-time list and discount pricing on any
                                of our products, updated daily.
                            </p>
                        </li>
                    </ul>
                    <div
                        class="pb-32 px-8 text-center at1024:max-w-[808px] at1024:mx-auto at1024:px-16 at1024:text-left"
                    >
                        <h3
                            class="font-bold leading-8 mb-4 text-2xl at1024:text-5xl"
                        >
                            On the path to delivering exactly what you need.
                        </h3>
                        <p
                            class="leading-tight mb-8 text-gray-300 text-lg at1024:text-xl"
                        >
                            We constantly enhance our website to make your work
                            easier, more efficient and more informed. Register
                            for an account today to get unlimited access.
                        </p>
                        <Link :href="route('register')" class="btn-blue-on-gray"
                        >Register now</Link
                        >
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script setup>
import { useForm } from "@inertiajs/vue3";
import { BaseSvg, SeclockInput, ManufacturerPreview } from "@/Components";

defineProps({
    manufacturer: {
        type: Object,
        default: null
    },
    series: {
        type: Array,
        default: () => []
    },
    featuredSeries: {
        type: Array,
        default: () => []
    },
    vendorCategories: {
        type: Array,
        default: () => []
    }
});

const form = useForm({
    email: null,
    password: null,
    remember: false,
});

function submit(event) {
    form.submit(event.target.method, event.target.action, {
        onSuccess: () => {
            form.reset();
        },
    });
}
</script>
